<div>
  @if (dataLine.label) {
    <span class="label">
      {{dataLine.label}}
    </span>
  } @else {
    <span class="label">
      {{dataLine.name}}
    </span>
  }
  <br>
    <span class="data">
      {{dataLine.value}}
    </span>
  </div>

  <ng-template #name>
    <span class="label">
      {{dataLine.name}}
    </span>
  </ng-template>
